import { AccountTable } from './AccountTable';
export default AccountTable;
